import { buildSupabaseAuthHeaders } from '@/lib/auth';

export interface SupabaseFetchOptions {
  requireJwt?: boolean;
  preferJwt?: boolean;
}

export async function applySupabaseAuth(
  init: RequestInit = {},
  options: SupabaseFetchOptions = {},
): Promise<RequestInit> {
  const headers = await buildSupabaseAuthHeaders(init.headers, options);

  return {
    ...init,
    headers,
  };
}

export async function fetchWithSupabaseAuth(
  input: RequestInfo | URL,
  init: RequestInit = {},
  options: SupabaseFetchOptions = {},
): Promise<Response> {
  const authedInit = await applySupabaseAuth(init, options);
  return fetch(input, authedInit);
}
